<template>
  <form class="search">
    <input type="text" :placeholder="searchLab" v-model="searchWord" />
    <button class="btn" @click.prevent="searchKeyword(), searchFilter()">
      <span>{{ searchLab }} </span> <i class="icon-search"></i>
    </button>
  </form>
</template>
<script>
export default {
  data() {
    return {
      searchWord: "",
    };
  },
  props: ["searchFilter", "searchLab", "searchPlaceHolder"],
  methods: {
    searchKeyword() {
      this.$emit("searchKeyword", this.searchWord);
    },
  },
  watch: {
    searchWord() {
      this.$emit("searchKeyword", this.searchWord);
    }
  }
};
</script>
